import {Vue} from 'ui.vue';


import './BXmakerAuthuserphoneEnterAuth.styl';

import './BXmakerAuthuserphoneEnterSmsCode';
import './BXmakerAuthuserphoneEnterUserCall';
import './BXmakerAuthuserphoneEnterBotCall';
import './BXmakerAuthuserphoneEnterBotSpeech';
import './BXmakerAuthuserphoneEnterSimPush';
import './BXmakerAuthuserphoneEnterAuthForm';
import './BXmakerAuthuserphoneEnterAuthByPasswordForm';
import './BXmakerAuthuserphoneEnterAuthByEmailCodeForm';
import './BXmakerAuthuserphoneEnterAuthByEmailCode';


Vue.component('BXmakerAuthuserphoneEnterAuth', {
    name: 'BXmakerAuthuserphoneEnterAuth',
    //language=Vue
    template: `
      <div class="bxmaker-authuserphone-enter-auth">

        <BXmakerAuthuserphoneHeader class="bxmaker-authuserphone-enter-auth__title">
          {{$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_AUTH_TITLE}}
        </BXmakerAuthuserphoneHeader>

        <BXmakerAuthuserphoneEnterAuthForm
            v-show="$root.isNeedShowAuthByPhoneForm"
        />

        <BXmakerAuthuserphoneEnterAuthByPasswordForm
            v-show="$root.isNeedShowAuthByPasswordForm"
        />

        <BXmakerAuthuserphoneEnterAuthByEmailCodeForm
            v-show="$root.isNeedShowAuthByEmailCodeForm"
        />

        <BXmakerAuthuserphoneEnterSmsCode
            v-show="$root.isNeedShowConfirmSmsCode"
        />

        <BXmakerAuthuserphoneEnterUserCall
            v-show="$root.isNeedShowConfirmUserCall"
        />

        <BXmakerAuthuserphoneEnterBotCall
            v-show="$root.isNeedShowConfirmBotCall"
        />

        <BXmakerAuthuserphoneEnterBotSpeech
            v-show="$root.isNeedShowConfirmBotSpeech"
        />

        <BXmakerAuthuserphoneEnterSimPush
            v-show="$root.isNeedShowConfirmSimPush"
        />

        <BXmakerAuthuserphoneEnterAuthByEmailCode
            v-show="$root.isNeedShowConfirmEmailCode"
        />

        <div class="bxmaker-authuserphone-enter-auth__change-confirm" v-if="$root.isNeedShowChangeConfirm">
          <BXmakerAuthuserphoneLink @onClick="$root.changeConfirmType">
            {{$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_CHANGE_CONFIRM_TYPE}}
          </BXmakerAuthuserphoneLink>
        </div>


        <div class="bxmaker-authuserphone-enter-auth__toregistration"
             v-if="($root.isNeedShowAuthByPhoneForm || $root.isNeedShowAuthByPasswordForm ) && $root.isEnabledRegister">
          <BXmakerAuthuserphoneLink @onClick="$root.toRegistration">
            {{$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_TO_REGISTRATION}}
          </BXmakerAuthuserphoneLink>
        </div>

      </div>
    `,
});